import React, { Component } from 'react'
import './stylesheets/notificationDetails.css'
import Header from '../../components/header/Header'
import {getNotificationDetails,getNotificationStatusUpdate} from '../../modules/serverCall'
import "react-datepicker/dist/react-datepicker.css";
import { Link  } from 'react-router-dom';
import Moment from 'moment';



 
export default class NotificationDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationdetails:'',
      notificationtype:'',
      currnetmonth:'',
      currnetyear:'',
      notificationdate:''
    }
  }


 

 componentDidMount () {
    window.scrollTo(0, 0);
    const accesstokendata =  localStorage.getItem('access_token');
    const readData = JSON.parse(accesstokendata);
    const cusId =  readData.userdata.user_id;
    let params = new URLSearchParams(window.location.pathname);
    var month = params.get("month");
    var year = params.get("year");
    var notificationID = params.get("notificationID");
   
    var sendData = {
        month:month,
        year:year,
        notificationID:parseInt(notificationID),
        techId:cusId
    }
    const fetchnotificationdetails = async () => {
      const responsenotification = await getNotificationDetails(sendData);
      const datarespnotification  = await responsenotification;
      if(datarespnotification !== '' && datarespnotification !== null && datarespnotification !== undefined){
        if(datarespnotification.ReadFlag === 0){
          var sendVal ={
            notificationID:parseInt(notificationID),
            techId:cusId,
            DeliveryFlag:1,
            ReadFlag:1,
            ModifiedDate:Moment(new Date()).format('YYYY-MM-DD'),
            ModifiedBy:cusId,
          }
          const responsenotificationUpdate = await getNotificationStatusUpdate(sendVal);
          const datarespnotificationUpdate  = await responsenotificationUpdate;
        }
        
      }
      
      

      this.setState({
        notificationdetails:datarespnotification,
      });
    };
    fetchnotificationdetails();
  }

  render() {
    var notificationdetailsdata = this.state.notificationdetails;
    // var notificationdetails = '';
    // var notificationdetailsDataArr = [];
    // if(notificationdetailsdata !=='' && notificationdetailsdata !==null && notificationdetailsdata !== undefined){
    //   notificationdetails = this.state.notificationdetails;
    //   for(var i = 0; i < notificationdetails.length; i++) {
    //       var notificationdetailsDataMain = {};
    //       notificationdetailsDataMain['NotificationID'] = notificationdetails[i].NotificationID;
    //       notificationdetailsDataMain['DisplayToDate'] = notificationdetails[i].DisplayToDate;
    //       notificationdetailsDataMain['DisplayFromDate'] = notificationdetails[i].DisplayFromDate;
    //       notificationdetailsDataMain['ModifiedDate'] = notificationdetails[i].ModifiedDate;
    //       notificationdetailsDataMain['Notification'] = notificationdetails[i].Notification;
          
    //       notificationdetailsDataArr.push(notificationdetailsDataMain);
    //   }
    // }
   const backLogoCircle = require ('../../assets/images/backBtnCircle.png');
    return (
      <div>
      <Header/>
        <div className="container">
          <div className="col-md-4 cardMainDataSyTask mb-3">
              <div className="p-card rounded px-3">
                <p className="mt-2 headingMain">Notification Details</p>
                  <Link  className="" to='/notification-front/'><img className="backBtn" src={backLogoCircle} alt="back"width="25" height="20"/></Link >

              </div>
          </div>
          <div className="row rowDataClass">
          {notificationdetailsdata !== '' ?
                <div className="col-sm-6 mb-3">
                  <div className="card card-task">
                    <div className="card-body card-body-task">
                       <h5 className="calenderDate">{notificationdetailsdata.DisplayFromDate +' - '+ notificationdetailsdata.DisplayToDate} </h5>
                        <h5 className="card-title">{notificationdetailsdata.Notification}</h5>
                       {/* <p className="card-text-primary">{notificationdetails.ConveyorReference+' - '+notificationdetails.Department}</p>
                       <p className="card-text-primary">{notificationdetails.Measures}</p>
                       <p className="card-text-primary">{notificationdetails.TechNames}</p> */}
                    </div>
                  </div>
                </div>
              :""
            }
          </div>
        </div>
      </div>

    )
  }
}





